module.exports = __webpack_public_path__ + "static/media/host-icon.b8b7668f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/host-icon.png
// module id = 67
// module chunks = 0